import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';
import { ShortenPipe } from '../../../pipes/shorten.pipe';
import { ShortenMiddlePipe } from '../../../pipes/shortenMiddle.pipe';
import { ApiService } from '../../../services/api.service';
import { CreativeAnalysisService } from '../../../services/creative-analysis.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CreativeAnalysisImage, CreativeAnalysisVideo, CreativeAnalysisCarousel, CreativeStyle } from '../../../interfaces/creative-analysis';


@Component({
  selector: 'app-creative-analysis-list',
  standalone: true,
  imports: [
    CommonModule,
    ShortenPipe,
    ShortenMiddlePipe,
    RouterLink,
    FormsModule,
    NgbTooltipModule
  ],
  templateUrl: './creative-analysis-list.component.html',
  styleUrl: './creative-analysis-list.component.css'
})
export class CreativeAnalysisListComponent implements OnInit {
  activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  creativeAnalysisService: CreativeAnalysisService = inject(CreativeAnalysisService);
  apiService: ApiService = inject(ApiService);
  toastrService: ToastrService = inject(ToastrService);

  // User Authentication
  authenticatedUser = this.authService.authenticatedUser;

  // Component-specific variables
  accountId: string = '';

  images: CreativeAnalysisImage[] = [];
  loadingImages = false;
  videos: CreativeAnalysisVideo[] = [];
  loadingVideos = false;
  carousels: CreativeAnalysisCarousel[] = [];
  loadingCarousels = false;
  export: {
    img: { loading: boolean; url: string | null };
    vid: { loading: boolean; url: string | null };
    car: { loading: boolean; url: string | null };
  } = {
    'img': {
      loading: false,
      url: null
    },
    'vid': {
      loading: false,
      url: null
    },
    'car': {
      loading: false,
      url: null
    }
  }
  creativeStyles: CreativeStyle[] = [];
  loadingCreativeStyles = false;

  ngOnInit(): void {
    
    // Check that user is authenticated (should be the case if this path is protected with AuthGuardService in app.routes.ts)
    this.authService.checkUserSignedIn().then(checkSign => {
      if (!checkSign) {
        // User is NOT signed in => Call AuthService.signOut() to redirect to Sign in page
        this.authService.signOut();
      } else {
        // User is signed in
        // Get Ad Account ID from URL params
        this.activatedRoute.params.subscribe((params: Params) => {
          this.accountId = params['id'];
          console.log(`Loading Ad Account#: ${this.accountId}`);

          this.loadingImages = true;
          this.creativeAnalysisService.listCreatives(this.accountId, 'img', 5000, 'full').then(images => {
            console.log("Images", images);
            this.images = images;
            this.loadingImages = false;
          });

          this.loadingVideos = true;
          this.creativeAnalysisService.listCreatives(this.accountId, 'vid', 5000, 'full').then(videos => {
            console.log("Videos", videos);
            this.videos = videos;
            this.loadingVideos = false;
          });

          this.loadingCarousels = true;
          this.creativeAnalysisService.listCreatives(this.accountId, 'car', 5000, 'full').then(carousels => {
            console.log("Carousels", carousels);
            this.carousels = carousels;
            this.loadingCarousels = false;
          });

          // Check if the user has access to the Ad Accounts section & this specific ad account
          this.authService.checkUserHasAccessToAdAccounts().then(adAccounts => {
            if(adAccounts === null || !adAccounts.some(adAccount => adAccount.id === this.accountId)) {
              // User does not have access to the account (or the user has no ad accounts at all)
              console.log("User does not have access to this ad account");
              this.toastrService.error("You do not have access to this Ad Account", "Access Denied");
              this.router.navigate(['/']);
            } else {
              // User has access to the account
              console.log("User has access to this ad account");

            }        
          });
        });
      }  
    });
  }

  exportToGS(type: 'img' | 'vid' | 'car') {
    console.log('Export to GS', type);
    this.export[type].loading = true;
    this.export[type].url = null;
    this.creativeAnalysisService.exportCreatives(this.accountId, type)
    .then(url => {
      console.log("exportCreatives response", url);
      this.export[type].loading = false;
      this.export[type].url = url;
    })
    .catch(error => {
      console.log("exportCreatives Error", error);
      this.export[type].loading = false;
    });
  }

}
